<template>
  <div>
    <div
      @mousedown="isPressed = true"
      @mouseup="isPressed = false"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false; isPressed = false"
      @click="!disabled &&$emit('click')"
    >
      <checkbox
        :value="selected"
        class="module"
        :class="{'submodule': submodule}"
        color="#0277BD"
        :disabled="disabled"
      >
        <div class="module__content">
          <div class="module__details">
            <h3 :class="['module__title', { 'module__title--disabled': disabled }]">
              {{ workflowLabel(title) }}
              <span v-if="optional" class="text-muted">
                {{ adminText('workflowsAll.optional_b16c7ac', '(optional)') }}
              </span>
            </h3>
            <p :class="['module__description', { 'module__description--disabled': disabled }]">{{ workflowLabel(description) }}</p>
          </div>
          <img v-if="!submodule" :src="iconSrc" :alt="adminText('workflowsAll.module_icon_c6118ef', 'module icon')" class="module__icon">
        </div>
      </checkbox>
    </div>
    <v-expand-transition>
      <slot />
    </v-expand-transition>
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
const ComponentState = Object.freeze({
  DEFAULT: 'default',
  DISABLED: 'disabled',
  HOVER: 'hover',
  PRESSED: 'pressed',
  SELECTED: 'selected',
})
export default {
  mixins: [WorkflowDisplay],
  name: 'new-module',
  props: {
    title: String,
    description: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    submodule: {
      type: Boolean,
      default: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
      isPressed: false,
    }
  },
  computed: {
    iconSrc() {
      let moduleType
      switch (this.title) {
      case 'Categories & zones':
        moduleType = 'categories-and-zones'
        break
      case 'Workshops':
        moduleType = 'workshops'
        break
      case 'Mobile app':
        moduleType = 'mobile-app'
        break
      case 'Create an event with a basic registration form':
        moduleType = 'none-module'
        break
      default:
        moduleType = 'tickets'
        break
      }

      let state = ComponentState.DEFAULT
      if (this.selected) {
        state = ComponentState.SELECTED
      } else if (this.disabled) {
        state = ComponentState.DISABLED
      }  else if (this.isPressed) {
        state = ComponentState.PRESSED
      } else if (this.isHover) {
        state = ComponentState.HOVER
      }

      return `/assets/extra-modules-icons/${state}/${moduleType}.svg`
    },
  },
}
</script>

<style scoped>
.module {
  padding: 1.5rem 1.5rem 1.5rem 1rem;
}

.submodule {
  padding: 0.75rem 0;
  margin: 1.5rem 1.5rem 0 3.25rem;
}

.module__content {
  display: flex;
  gap: 0.75rem;
}

@media screen and (max-width: 450px) {
  .module__content {
    flex-direction: column;
    align-items: center;
  }
}

.module__title {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.text-muted {
  color: #979797;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 120%;
}

.module__description {
  margin: 0.5rem 0 0 0;

  color: #666;
  font-family: "Source Sans Pro";
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.submodule .module__title {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0;
}

.submodule .text-muted {
  font-size: 1rem;
}

.submodule .module__description {
  margin-top: 0.125rem;
  font-size: 1rem;
}

::v-deep .v-input__slot {
  align-items: flex-start;
  margin-bottom: 0 !important;
}

::v-deep .v-input--selection-controls__input {
  margin-right: 0.75rem;
}

::v-deep .v-messages {
  display: none !important;
}

.module:active .module__title, .module:active .module__description,
.v-input--is-focused .module__title, .v-input--is-focused .module__description,
.v-input--is-label-active .module__title, .v-input--is-label-active .module__description {
  color: #0277BD;
}

.v-input--is-focused .v-input--selection-controls__ripple::before {
  color: #CEE4F2 !important;
}

.module__icon {
  height: 5.5rem;
  width: 5.5rem;
}

.module__title--disabled, .module__description--disabled {
  color: #979797 !important;
}
</style>
